class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.primaryImage = this.querySelector("[data-primary-image]");
    this.secondaryImage = this.querySelector("[data-secondary-image]");
    this.links = this.querySelectorAll("[data-product-link]");
    this.productTitle = this.querySelector("[data-product-title]");
    this.productPrice = this.querySelector("[data-current-price]");
    this.badges = this.querySelectorAll("[data-badge]");
  }

  connectedCallback() {
    this.addEventListener("change", (e) =>
      this.handleVariantButtonClick(e.target),
    );
  }

  getActiveBadge({
    isAvailable,
    isFinalSale,
    isOnSale,
    isPreorder,
    isBestseller,
    isNew,
  }) {
    if (isFinalSale) return "final-sale";
    if (isOnSale) return "sale";
    if (isPreorder) return "preorder";
    if (!isAvailable) return "out-of-stock";
    if (isBestseller) return "bestseller";
    if (isNew) return "new";
    return null;
  }

  updateBadges(activeBadge) {
    this.badges.forEach((badge) => {
      badge.hidden = badge.dataset.badge !== activeBadge;
    });
  }

  handleVariantButtonClick(input) {
    const variantUrl = input.dataset.productUrl;
    const primaryImage = input.dataset.primaryImage;
    const secondaryImage = input.dataset.secondaryImage;
    const variantTitle = input.dataset.productTitle;
    const varId = input.dataset.variantId;
    const isAvailable = input.dataset.available !== "false";
    const isOnSale = input.dataset.onSale === "true";
    const isFinalSale = input.dataset.finalSale === "true";
    const isPreorder = input.dataset.preorder === "true";
    const isBestseller = input.dataset.bestseller === "true";
    const isNew = input.dataset.new === "true";

    if (!variantUrl || !varId) return;

    this.links.forEach((link) => {
      link.href = variantUrl;
      if (link.hasAttribute("aria-label")) {
        link.setAttribute("aria-label", variantTitle);
      }
    });

    if (this.productTitle) {
      this.productTitle.innerHTML = `<a data-product-link href="${variantUrl}">${variantTitle}</a>`;
    }

    if (this.primaryImage && primaryImage) {
      this.primaryImage.innerHTML = `<div class="image"><picture><img alt="${variantTitle}" src="${primaryImage}" loading="lazy"></picture></div>`;
    }

    if (this.secondaryImage && secondaryImage) {
      this.secondaryImage.innerHTML = `<div class="image"><picture><img alt="${variantTitle}" src="${secondaryImage}" loading="lazy"></picture></div>`;
    }

    const priceTemplate = this.querySelector(`[data-price="${varId}"]`);
    if (priceTemplate && this.productPrice) {
      this.productPrice.innerHTML = priceTemplate.innerHTML;
    }

    this.updateBadges(
      this.getActiveBadge({
        isAvailable,
        isFinalSale,
        isOnSale,
        isPreorder,
        isBestseller,
        isNew,
      }),
    );
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
